import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["password", "passwordConfirmation"]

  validate(event) {
    const password = this.passwordTarget.value.trim()
    const confirmation = this.passwordConfirmationTarget.value.trim()

    //  Allow submission if both fields are empty (no update)
    // if (password === "" && confirmation === "") return

    //  Only one field filled
    if (password === "" || confirmation === "") {
      event.preventDefault()
      alert("Both password and confirmation must be filled to change the password.")
      return
    }

    //  Too short
    if (password.length < 6) {
      event.preventDefault()
      alert("Password must be at least 6 characters.")
      return
    }

    //  Mismatch
    if (password !== confirmation) {
      event.preventDefault()
      alert("Password and confirmation do not match.")
      return
    }

    // ✅ Valid update
  }
}
